<template>
  <div class="body">
    <div class="container">
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;600&display=swap" rel="stylesheet"/>
      <Intro />
      <Card :items="items" />
    </div>
  </div>
</template>

<script>
import Card from '../components/four-card-feature-section/Card.vue';
import Intro from '../components/four-card-feature-section/Intro.vue';

export default {
  name: 'CardFeatureSection',
  components: { Card, Intro },
  data() {
    return {
      items: [
        {
          id: 1,
          title: 'Supervisor Monitors',
          text: 'Monitor\'s activity to identify project roadblocks ',
          image_url: 'icon-supervisor.svg',
          classname: 'card--supervisor',
        },
        {
          id: 1,
          title: 'Team Builder',
          text: 'Scans our talent network to create the optimal team for your project',
          image_url: 'icon-team-builder.svg',
          classname: 'card--team',
        },
        {
          id: 1,
          title: 'karma',
          text: 'Regularly evaluates our talent to ensure quality',
          image_url: 'icon-karma.svg',
          classname: 'card--karma',
        },
        {
          id: 1,
          title: 'Calculator',
          text: 'Uses data from past projects to provide better delivery estimates',
          image_url: 'icon-calculator.svg',
          classname: 'card--calculator',
        },
      ],
    };
  },
};
</script>

<syyle src="../css/card-feature-section/global.css" scoped />
<style lang="scss" scoped>

  .body {
      --red: hsl(0, 78%, 62%);
      --cyan: hsl(180, 62%, 55%);
      --orange: hsl(34, 97%, 64%);
      --blue: hsl(212, 86%, 64%);
      --very-dark-blue: hsl(234, 12%, 34%);
      --grayish-blue: hsl(229, 6%, 66%);
      --very-light-gray: hsl(0, 0%, 98%);
      --white: white;

      --fs-base: 1rem;
      --fs-h2: 1.25rem;
      --fs-h1: 2rem;

      --sm-spacer: 2rem;
      --border-radius: 0.5rem;
      --ff-default: 'Poppins', sans-serif;

      font-size: var(--fs-base);
      font-family: var(--ff-default);
      background-color: var(--very-light-gray);

      min-height: 100vh;
      display: grid;
      justify-content: center;
      padding-top: calc(var(--sm-spacer) * 3);
      perspective: 120em;
    }
</style>
